import { render } from "./payroll-overtime.vue?vue&type=template&id=0f06f4ee"
import script from "./payroll-overtime.vue?vue&type=script&lang=js"
export * from "./payroll-overtime.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__